import { render, staticRenderFns } from "./modalEditarLiquidador.vue?vue&type=template&id=be0186de&"
import script from "./modalEditarLiquidador.vue?vue&type=script&lang=js&"
export * from "./modalEditarLiquidador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports